import { useEffect, useRef } from "react";

const FOCUSABLE_ELEMENTS = [
  "button",
  "[href]",
  "input",
  "select",
  "textarea",
  '[tabindex]:not([tabindex="-1"]'
];

export const useFocusTrap = ref => {
  const previousActiveElement = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    const focusHandler = event => {
      if (event.key !== "Tab") return;

      const focusableElements = ref.current.querySelectorAll(
        FOCUSABLE_ELEMENTS.join(", ")
      );
      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement =
        focusableElements[focusableElements.length - 1];

      if (
        (event.target === lastFocusableElement && !event.shiftKey) ||
        !ref.current.contains(event.target)
      ) {
        firstFocusableElement.focus();
        event.preventDefault();
      }

      if (event.target === firstFocusableElement && event.shiftKey) {
        lastFocusableElement.focus();
        event.preventDefault();
      }
    };

    document.addEventListener("keydown", focusHandler);

    previousActiveElement.current = document.activeElement;

    const firstFocusableElement = ref.current.querySelector(
      FOCUSABLE_ELEMENTS.join(", ")
    );

    if (firstFocusableElement) {
      firstFocusableElement.focus();
    }

    return () => {
      previousActiveElement.current.focus();
      document.removeEventListener("keydown", focusHandler);
    };
  }, []);
};
